<template>
  <div v-if="results === undefined" />
  <div v-else-if="results.length === 0">
    {{ tr(`No data available`) }}
  </div>
  <table v-else class="table table-sm table-striped">
    <thead>
      <tr>
        <th v-for="key in keys" :key="key">
          {{ key.toString().replace(/_/g, ' ') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in results" :key="index" @click="$emit('click', row)">
        <td v-for="key in keys" :key="key">
          <template v-if="getLen(row[key]) > charMax && charMax > 0">
            <tooltip>{{ row[key] }}</tooltip>
            <span>{{ subStr(row[key]) }}</span>
          </template>
          <template v-else>
            {{ row[key] }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'QuickTable',
    props: {
      results: { type: Array, default: undefined },
      charMax: { type: Number, default: 30 },
      whitelist: { type: Array, default: null },
      blacklist: { type: Array, default: null },
    },
    emits: ['click'],
    computed: {
      keys() {
        if (this.results === undefined || this.results.length === 0) {
          return []
        }
        if (this.whitelist && this.whitelist.length > 0) {
          return this.whitelist
        }
        if (this.blacklist && this.blacklist.length > 0) {
          return Object.keys(this.results[0]).filter((e) => {
            return !this.blacklist.includes(e)
          })
        }
        return Object.keys(this.results[0])
      },
    },
    methods: {
      tr,
      getLen(v) {
        return (v || '').toString().length
      },
      subStr(v) {
        return (v || '').toString().substring(0, this.charMax - 5) + ' ...'
      },
    },
  }
</script>

<style scoped></style>
